import InfoCard from "../elements/InfoCard";

export default ({
  title,
  desc,
  onClick,
  subtitle,
  profile,
  action,
  setActive,
  active,
  highlight,
}) => {
  return (
    <InfoCard
      onClick={onClick}
      highlight={highlight}
      type="clause"
      status={subtitle}
      action={action}
      setActive={setActive}
      active={active}
      desc={desc}
      theme={profile.theme}
      title={title}
    />
  );
};
